import {
  SignInPage,
  SignUpPage,
  ResetPasswordPage,
  UserProfile,
} from './pages';
import { withNavigationWatcher } from './contexts/navigation';
import { ThemeList } from './pages/manegement/themeSetting/themeList';
import PlaceholderPage from './pages/placeholder/PlaceholderPage';
import { MobiOfficeSupport } from './pages/support/MobiRouteSupport';

const routes = [
  {
    path: '/sign-in-form',
    element: SignInPage,
  },
  {
    path: '/sign-up-form',
    element: SignUpPage,
  },
  {
    path: '/reset-password-form',
    element: ResetPasswordPage,
  },
  {
    path: '/user-profile',
    element: UserProfile,
  },
  {
    path: '/dashboard',
    element: PlaceholderPage,
  },
  {
    path: '/planning',
    element: PlaceholderPage,
  },
  {
    path: '/tasks',
    element: PlaceholderPage,
  },
  {
    path: '/routes',
    element: PlaceholderPage,
  },
  {
    path: '/live-tracking',
    element: PlaceholderPage,
  },
  {
    path: '/companies',
    element: PlaceholderPage,
  },
  {
    path: '/customers',
    element: PlaceholderPage,
  },
  {
    path: '/vehicles',
    element: PlaceholderPage,
  },
  {
    path: '/orders',
    element: PlaceholderPage,
  },
  {
    path: '/drivers',
    element: PlaceholderPage,
  },
  {
    path: '/regions',
    element: PlaceholderPage,
  },
  {
    path: '/users',
    element: PlaceholderPage,
  },
  {
    path: '/roles',
    element: PlaceholderPage,
  },
  {
    path: '/theme',
    element: ThemeList,
  },
  {
    path: '/tickets',
    element: MobiOfficeSupport,
  },
  {
    path: '/vrp/drivers',
    element: PlaceholderPage,
  },
  {
    path: '/warehouses',
    element: PlaceholderPage,
  },
  {
    path: '/route-plans',
    element: PlaceholderPage,
  },
  {
    path: '/support',
    element: MobiOfficeSupport,
  },
];

export const appRoutes = routes.map((route) => {
  return {
    ...route,
    element: withNavigationWatcher(route.element, route.path),
  };
});
